export default "__VITE_ASSET__e4b49a29__"